import styled from "styled-components"

export const OutlineTitle = styled.h2`
  font-family: "sharp_grotesksemibold_25", sans-serif;
  text-transform: uppercase;
  letter-spacing: 10px;
  white-space: nowrap;
  font-size: 490px;
  line-height: 90%;
  -webkit-text-stroke: 1px;
  -webkit-text-fill-color: transparent;
  color: ${({ color }) => (color ? color : "#fff")};
  z-index: 3;
`
